import { create } from './Create/Create.i18n.ja'
import { update } from './Update/Update.i18n.ja'

export const detergentHistories = {
  create,
  update,
}
